import 'fullcalendar';
import 'fullcalendar/dist/fullcalendar.css';
import 'fullcalendar/dist/locale/fi';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import $ from 'jquery';

import { getFilteredEvents } from '../services/HandleFiltering';
import { selectEvent } from '../reducers/events';

import eventsToCalendar from '../services/eventsToCalendar';
import CalendarEventModal from './eventDetails/CalendarEventModal.jsx';

const mapStateToProps = state => ({
  events: getFilteredEvents(state),
  dateRange: { start: state.filter.STARTDATE, end: state.filter.ENDDATE },
  selectedEvent: state.events.selectedEvent
});

const mapDispatchToProps = dispatch => ({
  selectEvent: eventId => dispatch(selectEvent(eventId))
});

class Calendar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentEvent: {}
    };

    this.close = this.close.bind(this);
  }

  componentDidMount() {
    /* This is needed because the selected event from the map view otherwise is selected
    and therefore the CalendarEventModal is triggered */
    this.props.selectEvent(undefined);

    this.calendar = $('#calendar').fullCalendar({
      validRange: () => ({
        start: this.minDate,
        end: this.maxDate
      }),
      eventClick: (calEvent) => {
        const retEvent = this.props.events.find(event => parseInt(event.EVENT_ID, 10) === parseInt(calEvent.id, 10));
        this.setState({ currentEvent: retEvent });
        this.props.selectEvent(calEvent.id);
      }
    });

    /* This is necessary, otherwise events are not insterted to the calendar if changing
    the view from map back to calendar */
    this.addEventsToCalendar();
  }

  componentDidUpdate() {
    this.minDate = moment(this.props.dateRange.start).startOf('month');
    this.maxDate = moment(this.props.dateRange.end).startOf('month');
    this.calendar.fullCalendar('removeEvents');
    this.addEventsToCalendar();
  }

  addEventsToCalendar() {
    this.calendar.fullCalendar('addEventSource', eventsToCalendar(this.props.events));
  }

  close() {
    this.props.selectEvent(undefined);
  }

  render() {
    return (
      <div className="ibox-content">
        <div id="calendar" />
        <CalendarEventModal
          showModal={this.props.selectedEvent !== undefined}
          event={this.state.currentEvent}
          close={this.close}
        />
      </div>
    );
  }
}

Calendar.propTypes = {
  events: PropTypes.array.isRequired,
  dateRange: PropTypes.shape({
    start: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired
  }).isRequired,
  selectEvent: PropTypes.func.isRequired,
  selectedEvent: PropTypes.string
};

Calendar.defaultProps = {
  selectedEvent: undefined
};

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);



// WEBPACK FOOTER //
// ./src/components/Calendar.jsx